import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { HttpParams } from '@angular/common/http';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';

import { InspectorExtranjeroService } from './inspectorextranjero.service';
import { InspectorExtranjeroItemResultsViewModel, InspectorExtranjeroViewModel } from './inspectorextranjero.types';
import { Tc } from '../../../core/_infrastructure/types/common';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-inspectorextranjero-list',
    templateUrl: './inspectorextranjero-list.component.html',
})
export class InspectorExtrajeroListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    resultInspExtranjeros: InspectorExtranjeroItemResultsViewModel;
    listPais: Tc[];
    cols: any[];
    public isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private inspectorextranjeroService: InspectorExtranjeroService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.resultInspExtranjeros = new InspectorExtranjeroItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Nombre', header: 'Nombre' },
            { field: 'IdPaisDescripcion', header: 'País' },
            { field: 'Habilitado', header: 'Habilitado' },
        ];

        this.form = this.fb.group({
            Nombre: '',
            Habilitado: true,
            IdPais: null,
        });

        this.globalService.getAllPaises().subscribe(res => {
            this.listPais = res;
        });

        this.loadBack();
    }

    loadBack() {
        if (
            this.inspectorextranjeroService.currentFilterInspExtranjero.Nombre != '' ||
            this.inspectorextranjeroService.currentFilterInspExtranjero.IdPais > 0 ||
            !this.inspectorextranjeroService.currentFilterInspExtranjero.Habilitado
        ) {
            this.form.patchValue({
                Nombre: this.inspectorextranjeroService.currentFilterInspExtranjero.Nombre,
                IdPais: this.inspectorextranjeroService.currentFilterInspExtranjero.IdPais,
                Habilitado: this.inspectorextranjeroService.currentFilterInspExtranjero.Habilitado,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.inspectorextranjeroService.currentFilterInspExtranjero.Nombre = this.form.value.Nombre;
        this.inspectorextranjeroService.currentFilterInspExtranjero.IdPais = this.form.value.IdPais;
        this.inspectorextranjeroService.currentFilterInspExtranjero.Habilitado = this.form.value.Habilitado;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('Nombre', this.form.value.Nombre);
        params = params.append('IdPais', this.form.value.IdPais);
        params = params.append('Habilitado', this.form.value.Habilitado);

        this.loading = true;
        this.inspectorextranjeroService.getInspExtranjeroPagedByFilter(params).subscribe(result => {
            this.resultInspExtranjeros = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onPaging(event: any) {
        this.Search(event.page);
    }

    onCleanButton() {
        this.form.setValue({
            Nombre: '',
            Habilitado: true,
            IdPais: null,
        });
        this.searchingButton = false;
        this.isCollapsed = false;
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/general/inspectorextranjero/create']);
    }

    onEdit(item: InspectorExtranjeroViewModel) {
        this.router.navigate(['/mantenimiento/general/inspectorextranjero/edit', item.Id]);
    }

    onDelete(item: InspectorExtranjeroViewModel) {
        this.inspectorextranjeroService.deleteInspExtranjero(item.Id).subscribe(() => {
            this.onSearchButton();
        });
    }
}
